import {
  Dialog as MUIDialog,
  DialogProps as MUIDialogProps,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
  DialogContentProps,
} from "@/common/styles/style";
import { Close } from "@mui/icons-material";
import { ReactNode } from "react";
import { styles } from "./style";

interface DialogProps extends MUIDialogProps {
  open: boolean;
  title: string;
  onClose: () => void;
  contentChildren: ReactNode;
  actionsChildren?: ReactNode;
  contentProps?: DialogContentProps;
}

export default function Dialog({
  open,
  title,
  onClose,
  contentChildren,
  actionsChildren,
  contentProps,
  ...props
}: DialogProps) {
  return (
    <MUIDialog open={open} {...props}>
      <DialogTitle sx={styles.dialogTitle}>
        <Typography>{title}</Typography>
      </DialogTitle>
      <IconButton aria-label="close" onClick={onClose} sx={styles.iconButton}>
        <Close />
      </IconButton>
      <DialogContent sx={styles.dialogContent} {...contentProps}>
        {contentChildren}
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>{actionsChildren}</DialogActions>
    </MUIDialog>
  );
}
